import React from 'react';
import PropTypes from 'prop-types';
import { TableHeaderSorterSC, BodyWrapper, SortSC } from './table-header-sorter.styled';
import { ReactComponent as Chevron } from '../../../../assets/img/svg/chevron-down-light.svg';
import { ReactComponent as ChevronDark } from '../../../../assets/img/svg/chevron-down-dark.svg';

/**
 * Table header with sorting feature
 * @param {object} param0 props
 */
function TableHeaderSorter({ children, sortKey, onChange, sortDirection, allowSortOff = true }) {
  /**
   * Handle sort direction change
   */
  function handleClick() {
    if (onChange) {
      if (sortDirection === 'none' || !sortDirection) {
        onChange(sortKey, 'asc');
      } else if (sortDirection === 'asc') {
        onChange(sortKey, 'desc');
      } else {
        onChange(sortKey, allowSortOff ? 'none' : 'asc');
      }
    }
  }

  /**
   * Get chevron combination for order
   */
  function getChevrons() {
    if (sortDirection === 'desc') {
      return (
        <>
          <Chevron />
          <ChevronDark />
        </>
      );
    } else if (sortDirection === 'asc') {
      return (
        <>
          <ChevronDark />
          <Chevron />
        </>
      );
    } else {
      return (
        <>
          <Chevron />
          <Chevron />
        </>
      );
    }
  }

  return (
    <TableHeaderSorterSC onClick={handleClick} sortKey={sortKey}>
      <BodyWrapper>
        {children}
        {sortKey !== undefined && <SortSC>{getChevrons()}</SortSC>}
      </BodyWrapper>
    </TableHeaderSorterSC>
  );
}

TableHeaderSorter.propTypes = {
  sortDirection: PropTypes.oneOf(['none', 'asc', 'desc']),
  sortKey: PropTypes.string,
};

export default TableHeaderSorter;
